import { useEffect, useRef } from 'react';
import io from 'socket.io-client';
// eslint-disable-next-line
const useSocket = (url: string) => {
  // eslint-disable-next-line
  let socket = useRef<any>(null);

  useEffect(() => {
    const connect = async () => {
      try {
        // Check if socket already exists and URL hasn't changed

        // const newSocket = io(url);

        socket.current = io(url);
        // setSocket(newSocket);

        // ... rest of the connection logic

        socket.current.on('connect', () => {
          console.log('Connected to Socket.IO server!');
        });

        socket.current.on('disconnect', () => {
          console.log('Disconnected from Socket.IO server!');
        });
      } catch (error) {
        console.error('Error connecting to Socket.IO:', error);
      }
    };

    connect();

    // Cleanup function to disconnect on unmount
    return () => {
      if (socket) socket.current.disconnect();
    };
  }, [url, socket]); // Add socket as a dependency

  return { socket };
};

export default useSocket;
